<template>
	<page-container>
		<p style="font-size: 30px; line-height: 45px;" class="f-c-33 f-w-500">重置密码</p>
		<div class="input-item" style="margin-top: 17px;">
			<input class="form-input" type="text" autofocus="" placeholder="请输入您的手机号" @keyup.enter="submit()" @input="phoneWarn = ''" v-model="form.phone" />
			<div class="input-item-tip" v-if="phoneWarn">{{ phoneWarn }}</div>
		</div>
		<div class="input-item">
			<input class="form-input" autofocus="" @keyup.enter="submit()" placeholder="请输入短信验证码" v-model="form.code" />
			<div class="button-min-inner button-min" @click="getCode" v-if="!getting">获取验证码</div>
			<div class="button-min-inner button-min" v-if="getting">重新获取 {{ time }}s</div>
			<div class="input-item-tip" v-if="codeWarn">{{ codeWarn }}</div>
		</div>
    <div class="input-item">
			<input class="form-input" type="password" autocomplete="new-password" autofocus="" placeholder="请设置新密码（6-16位数字和字母）" @keyup.enter="submit()" @input="passwordWarn = ''" v-model="form.password" />
			<div class="input-item-tip" v-if="passwordWarn">{{ passwordWarn }}</div>
		</div>
		<button style="margin-top: 17px;" class="form-btn" type="primary" @click="submit()" @keyup.enter="submit()">重置密码</button>
		<p class="f-s-16 f-c-33 f-w-500" style="padding: 32px 0 53px 0; text-align: center;">
      <span @click="login" class="button-min" style="margin-right: 29px;">返回登录</span>
      <span @click="register" class="button-min">立即注册</span>
    </p>
    <dialog-select slot="footer" ref="dialogSelect"></dialog-select>
	</page-container>
</template>

<script>
import pageContainer from '../components/page-container.vue';
import dialogSelect from '../components/select.vue';
import md5 from 'js-md5';
export default {
	name: 'register',
	data() {
		return {
			form: {
				password: '',
				phone: '',
				code: '',
			},
			passwordWarn: '',
			phoneWarn: '',
			codeWarn: '',
			bubuid: '',
			getting: false,
			time: 60,
			loading: false,
		};
	},
	components: {
		pageContainer,
    dialogSelect,
	},
	methods: {
    register() {
      this.$router.push({
				path: '/register',
			});
    },
		submit(uid, sid) {
			if (!this.loading && this.validation()) {
        this.loading = true;
        this.$api.updatePwd({
					params: {
            'USER.LOGIN_ID': this.form.phone,
            'USER.NEW_PASSWORD': this.form.password,
            APP_TOKEN: '9C4F2C2F67E34BB29BF296DBDBF26922',
            'USER.UID': uid || '',
            'USER.SERVICE_ID': sid || '',
            'USER.SMS_CODE': this.form.code,
					},
					headers: {
						token: this.bubuid,
					},
					success: res => {
            let result = res.extraData;
						if (result['USER_LIST'] && result['USER_LIST'].length > 1) {
							result['USER_LIST'].map(ele => {
								ele.name = ele['USER.NAME'];
							});
							this.$refs.dialogSelect.show({
								list: result['USER_LIST'],
								title: '选择重置密码的角色',
								select: res => {
                  this.submit(res['USER.UID'], res['USER.SERVICE_ID'])
								},
							});
              return;
						}
						alert('密码已重置，请重新登录');
						this.$router.push('/');
					},
					fail: res => {
						if (res.msg) {
							if (res.msg.indexOf('验证码') !== -1) {
								this.codeWarn = res.msg;
							} else if (res.msg.indexOf('密码') !== -1) {
								this.passwordWarn = res.msg;
							} else {
								this.phoneWarn = res.msg;
							}
						}
					},
					complete: () => {
						this.loading = false;
					},
				});
      }
		},
		login() {
			this.$router.push({
				path: '/',
			});
		},
		validation() {
			this.phoneWarn = '';
			this.codeWarn = '';
			this.passwordWarn = '';
			if (!this.form.phone) {
				this.phoneWarn = '手机号不能为空';
				return false;
			}
			if (!this.form.code) {
				this.codeWarn = '验证码不能为空';
				return false;
			}
      if (!this.form.password) {
				this.passwordWarn = '密码不能为空';
				return false;
			}
			return true;
		},
		getCode() {
			if (!this.getting) {
				if (this.form.phone.length != 11) {
					this.phoneWarn = '请填写正确的手机号码';
				} else {
					this.getting = true;
					let dis = function(that) {
						setTimeout(() => {
							that.time--;
							if (that.time == 0) {
								that.getting = false;
								that.time = 59;
							} else {
								dis(that);
							}
						}, 1000);
					};
					dis(this);
					this.$api.getCode({
						params: Object.assign({}, this.getMd5Key(this.form.phone), {
							APP_TOKEN: '9C4F2C2F67E34BB29BF296DBDBF26922',
							PHONE: this.form.phone,
							APP_SOURCE: 2,
						}),
						success: res => {
							this.bubuid = res.extraData.bubuId;
						},
					});
				}
			}
		},
		getMd5Key(phone) {
			let time = new Date();
			let y = time.getFullYear();
			let m = time.getMonth() + 1;
			let d = time.getDate();
			let day = [y, m >= 10 ? m : '0' + m, d >= 10 ? d : '0' + d];
			let rdmKey = (parseInt((Math.random() + 1) * Math.pow(10, 8)) + '').substr(1, 8) + day.join('');
			return {
				RDM_KEY: rdmKey,
				SER_KEY: md5(phone + rdmKey + 'akx_808088'),
			};
		},
	},
};
</script>

<style scoped lang="scss">
.input-item {
	padding-bottom: 17px;
	padding-top: 17px;
	position: relative;
}
.input-item-tip {
	position: absolute;
	left: 0;
	bottom: -8px;
	font-size: 14px;
	color: #f46c50;
	line-height: 21px;
}
.input-item-tip:before {
	content: '';
	display: inline-block;
	width: 14px;
	height: 14px;
	background-position: center;
	background-size: contain;
	vertical-align: middle;
	margin-right: 6px;
	background-image: url(../assets/cut.png);
}
.button-min-inner {
	position: absolute;
	top: 32px;
	line-height: 24px;
	font-size: 16px;
	right: 12px;
}
.button-min {
	color: #f46c50;
	cursor: pointer;
}
.button-min:hover {
	opacity: 0.8;
}
</style>
